/**
 * Auto SEO Enhancements Script
 * Automatically implements SEO best practices across the site
 */

document.addEventListener('DOMContentLoaded', function() {
  
  // 1. Auto-generate meta descriptions for product pages
  function generateMetaDescription() {
    const existingMeta = document.querySelector('meta[name="description"]');
    
    // Only generate if missing or if existing is too long (over 160 chars)
    if (!existingMeta || existingMeta.content.trim() === '' || existingMeta.content.length > 160) {
      let description = '';
      
      // For product pages
      if (window.location.pathname.includes('/products/')) {
        const productTitle = document.querySelector('.product__title h1, .product__title h2');
        const productPrice = document.querySelector('.price-item--regular, .price__regular .price-item');
        
        if (productTitle) {
          // Create concise description
          const title = productTitle.textContent.trim();
          const shortTitle = title.length > 40 ? title.substring(0, 40) + '...' : title;
          
          description = `Buy ${shortTitle}`;
          if (productPrice) {
            description += ` for ${productPrice.textContent.trim()}`;
          }
          description += '. Fast shipping available.';
          
          // Ensure under 160 characters
          if (description.length > 160) {
            description = `Buy ${shortTitle}. Fast shipping available.`;
          }
        }
      }
      
      // For collection pages
      else if (window.location.pathname.includes('/collections/')) {
        const collectionTitle = document.querySelector('h1, .collection__title');
        const productCount = document.querySelectorAll('.collection-product-card, .card-product').length;
        
        if (collectionTitle) {
          description = `Browse ${collectionTitle.textContent.trim()}`;
          if (productCount > 0) {
            description += ` - ${productCount}+ products available`;
          }
          description += '. Find the best deals with fast shipping and secure checkout.';
        }
      }
      
      // For search pages
      else if (window.location.pathname.includes('/search')) {
        const searchTerm = new URLSearchParams(window.location.search).get('q');
        if (searchTerm) {
          description = `Search results for "${searchTerm}". Find the best products with fast shipping and secure checkout.`;
        }
      }
      
      // Add or update meta description
      if (description) {
        let metaDesc = document.querySelector('meta[name="description"]');
        if (!metaDesc) {
          metaDesc = document.createElement('meta');
          metaDesc.name = 'description';
          document.head.appendChild(metaDesc);
        }
        metaDesc.content = description.substring(0, 160); // Keep under 160 characters
      }
    }
  }

  // 2. Auto-add Open Graph tags
  function generateOpenGraphTags() {
    const ogTags = [
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.href },
      { property: 'og:site_name', content: document.title.split(' – ').pop() }
    ];
    
    // Add product-specific OG tags
    if (window.location.pathname.includes('/products/')) {
      const productTitle = document.querySelector('.product__title h2, h1');
      const productImage = document.querySelector('.product__media img, .collection-product-img img');
      const productPrice = document.querySelector('.price-item--regular, .price__regular .price-item');
      
      if (productTitle) {
        ogTags.push({ property: 'og:title', content: productTitle.textContent.trim() });
        ogTags.push({ property: 'og:type', content: 'product' });
      }
      
      if (productImage && productImage.src) {
        ogTags.push({ property: 'og:image', content: productImage.src });
        ogTags.push({ property: 'og:image:alt', content: productImage.alt || (productTitle ? productTitle.textContent.trim() : 'Product image') });
      }
      
      if (productPrice) {
        ogTags.push({ property: 'product:price:amount', content: productPrice.textContent.replace(/[^\d.,]/g, '') });
        ogTags.push({ property: 'product:price:currency', content: 'GBP' });
      }
    }
    
    // Add OG tags that don't already exist
    ogTags.forEach(function(tag) {
      if (!document.querySelector(`meta[property="${tag.property}"]`)) {
        const meta = document.createElement('meta');
        meta.setAttribute('property', tag.property);
        meta.content = tag.content;
        meta.setAttribute('data-auto-seo', 'true');
        document.head.appendChild(meta);
      }
    });
  }

  // 3. Auto-optimize heading structure (H1, H2, H3 hierarchy)
  function optimizeHeadingStructure() {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    let hasH1 = false;
    
    headings.forEach(function(heading) {
      if (heading.tagName === 'H1') {
        hasH1 = true;
      }
    });
    
    // If no H1 exists, convert the most prominent heading to H1
    if (!hasH1) {
      const mainTitle = document.querySelector('.product__title h2, .collection__title, .page-title h2, h2');
      if (mainTitle && mainTitle.tagName === 'H2') {
        const newH1 = document.createElement('h1');
        newH1.innerHTML = mainTitle.innerHTML;
        newH1.className = mainTitle.className;
        mainTitle.parentNode.replaceChild(newH1, mainTitle);
      }
    }
  }

  // 4. Auto-optimize internal linking
  function optimizeInternalLinks() {
    const links = document.querySelectorAll('a[href]');
    
    links.forEach(function(link) {
      const href = link.getAttribute('href');
      
      // Add title attributes to internal links without them
      if (href && href.startsWith('/') && !link.hasAttribute('title') && link.textContent.trim()) {
        link.setAttribute('title', link.textContent.trim());
      }
      
      // Add rel="noopener" to external links for security
      if (href && (href.startsWith('http') && !href.includes(window.location.hostname))) {
        if (!link.hasAttribute('rel')) {
          link.setAttribute('rel', 'noopener');
        }
      }
    });
  }

  // 5. Auto-add Twitter Card tags
  function generateTwitterCardTags() {
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:url', content: window.location.href }
    ];
    
    if (window.location.pathname.includes('/products/')) {
      const productTitle = document.querySelector('.product__title h2, h1');
      const productImage = document.querySelector('.product__media img, .collection-product-img img');
      const productDescription = document.querySelector('.product__description, .product-description__content');
      
      if (productTitle) {
        twitterTags.push({ name: 'twitter:title', content: productTitle.textContent.trim() });
      }
      
      if (productDescription) {
        twitterTags.push({ name: 'twitter:description', content: productDescription.textContent.trim().substring(0, 200) });
      }
      
      if (productImage && productImage.src) {
        twitterTags.push({ name: 'twitter:image', content: productImage.src });
      }
    }
    
    // Add Twitter tags that don't already exist
    twitterTags.forEach(function(tag) {
      if (!document.querySelector(`meta[name="${tag.name}"]`)) {
        const meta = document.createElement('meta');
        meta.setAttribute('name', tag.name);
        meta.content = tag.content;
        meta.setAttribute('data-auto-seo', 'true');
        document.head.appendChild(meta);
      }
    });
  }

  // 6. Auto-optimize image loading for SEO
  function optimizeImageLoading() {
    const images = document.querySelectorAll('img');
    
    images.forEach(function(img) {
      // Add loading="lazy" to images below the fold
      if (!img.hasAttribute('loading')) {
        const rect = img.getBoundingClientRect();
        if (rect.top > window.innerHeight) {
          img.setAttribute('loading', 'lazy');
        }
      }
      
      // Add width and height attributes if missing (helps with CLS)
      if (!img.hasAttribute('width') && !img.hasAttribute('height')) {
        img.onload = function() {
          if (!this.hasAttribute('width')) {
            this.setAttribute('width', this.naturalWidth);
          }
          if (!this.hasAttribute('height')) {
            this.setAttribute('height', this.naturalHeight);
          }
        };
      }
    });
  }

  // 7. Auto-add canonical tags if missing
  function ensureCanonicalTag() {
    if (!document.querySelector('link[rel="canonical"]')) {
      const canonical = document.createElement('link');
      canonical.rel = 'canonical';
      canonical.href = window.location.href.split('?')[0]; // Remove query parameters
      canonical.setAttribute('data-auto-seo', 'true');
      document.head.appendChild(canonical);
    }
  }

  // 8. Auto-optimize page titles
  function optimizePageTitle() {
    const currentTitle = document.title;
    
    // For product pages, create shorter, optimized titles
    if (window.location.pathname.includes('/products/')) {
      const productTitle = document.querySelector('.product__title h1, .product__title h2');
      const productPrice = document.querySelector('.price-item--regular, .price__regular .price-item');
      
      if (productTitle) {
        // Create concise title
        let title = productTitle.textContent.trim();
        
        // Shorten long titles
        if (title.length > 35) {
          title = title.substring(0, 35) + '...';
        }
        
        let newTitle = title;
        if (productPrice) {
          const price = productPrice.textContent.trim();
          newTitle += ` - ${price}`;
        }
        
        // Add shop name if there's room
        const shopName = document.title.split(' – ').pop();
        if (newTitle.length + shopName.length + 3 <= 60) {
          newTitle += ` | ${shopName}`;
        }
        
        // Ensure under 60 characters total
        if (newTitle.length > 60) {
          newTitle = title + ` | ${shopName}`;
          if (newTitle.length > 60) {
            newTitle = title.substring(0, 60 - shopName.length - 3) + ` | ${shopName}`;
          }
        }
        
        document.title = newTitle;
      }
    }
  }

  // 9. Auto-add schema markup for organization
  function generateOrganizationSchema() {
    if (!document.querySelector('script[type="application/ld+json"][data-org-seo]')) {
      const orgSchema = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": document.title.split(' – ').pop(),
        "url": window.location.origin,
        "sameAs": []
      };
      
      // Look for social media links
      const socialLinks = document.querySelectorAll('a[href*="facebook"], a[href*="twitter"], a[href*="instagram"], a[href*="youtube"]');
      socialLinks.forEach(function(link) {
        if (link.href.startsWith('http')) {
          orgSchema.sameAs.push(link.href);
        }
      });
      
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-org-seo', 'true');
      script.textContent = JSON.stringify(orgSchema);
      document.head.appendChild(script);
    }
  }

  // 10. Auto-optimize for Core Web Vitals
  function optimizeWebVitals() {
    // Preload critical resources
    const criticalImages = document.querySelectorAll('img[src*="hero"], img[src*="banner"], .product__media img:first-child');
    criticalImages.forEach(function(img, index) {
      if (index < 2) { // Only preload first 2 critical images
        const link = document.createElement('link');
        link.rel = 'preload';
        link.as = 'image';
        link.href = img.src;
        link.setAttribute('data-auto-seo', 'true');
        document.head.appendChild(link);
      }
    });
    
    // Add fetchpriority="high" to above-the-fold images
    const aboveFoldImages = document.querySelectorAll('img');
    aboveFoldImages.forEach(function(img) {
      const rect = img.getBoundingClientRect();
      if (rect.top < window.innerHeight && !img.hasAttribute('fetchpriority')) {
        img.setAttribute('fetchpriority', 'high');
      }
    });
  }

  // Run all SEO enhancements
  try {
    generateMetaDescription();
    generateOpenGraphTags();
    optimizeHeadingStructure();
    optimizeInternalLinks();
    generateTwitterCardTags();
    optimizeImageLoading();
    ensureCanonicalTag();
    optimizePageTitle();
    generateOrganizationSchema();
    optimizeWebVitals();
    
    console.log('Auto SEO enhancements applied successfully');
  } catch (error) {
    console.warn('Some SEO enhancements could not be applied:', error);
  }

  // Re-run optimizations when new content is loaded (for AJAX/dynamic content)
  const observer = new MutationObserver(function(mutations) {
    let shouldRerun = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.tagName === 'IMG' || node.querySelector('img'))) {
            shouldRerun = true;
          }
        });
      }
    });
    
    if (shouldRerun) {
      setTimeout(function() {
        optimizeImageLoading();
        optimizeInternalLinks();
      }, 100);
    }
  });

  // Start observing for dynamic content
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});
